import { Component, OnInit } from '@angular/core';
import { ClinicProductService } from 'src/app/_services/clinic-product.service';

@Component({
  selector: 'app-clinic-orders',
  templateUrl: './clinic-orders.component.html',
  styleUrls: ['./clinic-orders.component.scss'],
})
export class ClinicOrdersComponent implements OnInit {
  orders: any[] = [];
  loading: boolean = true;
  filteringFor: string = '';
  // Removed products: any[] = [];
  
  metaData = {
    totalRecords: 0,
    limit: 10, // default page size, matching table default
    offset: 0,
    loading: true,
    globalFilter: '',
    sort: '',
    id: '',
  };

  orderColumns: any[] = [
    { field: 'order_number', header: 'Order Number' },
    { field: 'order_date', header: 'Order Date' },
    { field: 'date_required', header: 'Required Date' },
    { field: 'order_status', header: 'Status' },
    { field: 'order_total', header: 'Total' },
    { field: 'clinic.name', header: 'Clinic Name' },
    { field: 'clinic.professional_nurse', header: 'Professional Nurse' },
    { field: 'clinic.province', header: 'Province' },
  ];

  productColumns: any[] = [
    { field: 'order_number', header: 'Order Number' },
    { field: 'order_date', header: 'Order Date' },
    { field: 'date_required', header: 'Required Date' },
    { field: 'order_status', header: 'Status' },
    { field: 'order_total', header: 'Total' },
    { field: 'clinic.name', header: 'Clinic Name' },
    { field: 'clinic.professional_nurse', header: 'Professional Nurse' },
    { field: 'clinic.province', header: 'Province' },
  ];

  constructor(private clinicProductService: ClinicProductService) {}

  ngOnInit(): void {}

  getFilterInputValue(event: any) {
    const inputelement = event.target as HTMLInputElement;
    this.filteringFor = 'Filtering for: ' + inputelement.value;
    if (inputelement.value === '') {
      this.filteringFor = '';
    }
    return inputelement.value;
  }

  lazyLoadOrders(event: any) {
    this.loading = true;
    this.metaData = {
      ...this.metaData,
      limit: event.rows || 10,
      offset: event.first || 0,
      globalFilter: event.globalFilter || '',
    };

    this.clinicProductService.getClinicOrders(this.metaData).subscribe(
      (response: any) => {
        this.orders = response.body.data;
        this.metaData.totalRecords = response.body.count;
        this.clinicProductService.updateOrders(this.orders);
        this.metaData.loading = false;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching orders:', error);
        this.loading = false;
      }
    );
  }

  resolveField(data: any, field: string): any {
    return field.split('.').reduce((acc, part) => acc && acc[part], data);
  }
}
